export default __webpack_public_path__ + "static/media/022-trash-can.03d29b4d.svg";